// extracted by mini-css-extract-plugin
export default {"Rotate":"SearchSelect_Rotate__jf8oe","search":"SearchSelect_search__5IBiB","chevron":"SearchSelect_chevron__H2Snq","--open":"SearchSelect_--open__4ymde"};